import React, { FC, useState, useEffect } from 'react'
/** @jsx jsx */
import { Transition, TransitionGroup } from 'react-transition-group'
import { CloseIcon } from '@components/Icons'
import { Button } from '@components/Button'
import {
  CloseBtnWrapper,
  closeButtonStyles,
  TRANSITION_DELAY
} from './ApptBanner.elements'

import {
  LearnMoreBannerWrapper,
  InnerWrapper,
  MessageWrapper,
  learnMoreBannerBtnStyles,
  IconWrapper
} from "@components/InfoBanner/LearnMoreBanner.elements";
import {jsx, css} from "@emotion/core";
import { ListMedalIcon } from '@components/Icons/ListMedal'

type Props = {
  message?: string
  initiateOpen?: boolean
  onLearnMore?: () => void
  icon?: JSX.Element
}

export const LearnMoreBanner: FC<Props> = ({
                                        message = <span>Health IQ membership rewards are better than ever.</span>,
                                        initiateOpen,
                                        onLearnMore,
                                        icon = <ListMedalIcon/>
                                      }) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!initiateOpen)
  const [isActive, setIsActive] = useState<boolean>(true)

  useEffect(() => {
    setIsOpen(true)
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }
  const handleHideContent = () => {
    setIsActive(false)
  }

  return (
    <TransitionGroup>
      {isOpen && (
        <Transition
          key="learn-more-banner"
          in={!initiateOpen}
          appear={!initiateOpen}
          timeout={TRANSITION_DELAY}
        >
          {state => (
            <LearnMoreBannerWrapper state={state}>
              <InnerWrapper state={state}>
                <MessageWrapper>
                  <IconWrapper>
                    {icon}
                  </IconWrapper>
                  {message}
                  <Button
                    onClick={onLearnMore}
                    variant="link-white"
                    css={learnMoreBannerBtnStyles}
                  >
                    See if you qualify.
                  </Button>
                </MessageWrapper>
              </InnerWrapper>

              <CloseBtnWrapper>
                <Button
                  onClick={handleClose}
                  circled
                  css={closeButtonStyles}
                  aria-label="Close info banner"
                >
                  <CloseIcon />
                </Button>
              </CloseBtnWrapper>
            </LearnMoreBannerWrapper>
          )}
        </Transition>
      )}
    </TransitionGroup>
  )
}
